/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Leerjaarcombo_Drievier4Inputs */

const nl_enums_leerjaarcombo_drievier4 = /** @type {(inputs: Enums_Leerjaarcombo_Drievier4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3/4`)
};

/**

* @param {Enums_Leerjaarcombo_Drievier4Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_leerjaarcombo_drievier4 = /** @type {((inputs?: Enums_Leerjaarcombo_Drievier4Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Leerjaarcombo_Drievier4Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_leerjaarcombo_drievier4(inputs)
});
export { enums_leerjaarcombo_drievier4 as "enums.LeerjaarCombo.DrieVier" }